const codes = {
	JVB000: { code: "JVB000", error: "unkown_error" },
	JVB001: { code: "JVB001", message: "CORRECT_RESULT" },
	JVB002: { code: "JVB002", error: "Bad Parameters" },
	JVB003: { code: "JVB003", error: "Authentication" },

	JVB004: { code: "JVB004", error: "User SalesForce Already exists" },
	JVB005: { code: "JVB005", error: "INTERNAL_UNKOWN_ERROR" },
	JVB006: { code: "JVB006", error: "VALIDATION_USER_FAILED" },
	JVB007: { code: "JVB007", error: "FAILED_CREATING_USER" },
	JVB008: { code: "JVB008", error: "INVALID_DOCTYPE" },
	JVB009: { code: "JVB009", error: "INVALID_CATCHA" },
	JVB010: { code: "JVB010", error: "PASSWORD_ALREADY_USED" },
	JVB011: { code: "JVB011", error: "DUPLICATES_DETECTED" },

	JVB100: { code: "JVB100", error: "Correct Test" },
};

module.exports = codes;
